import React from 'react'
import { SIZES } from '../constants'

const Divider = (props) => {
  return (
    <div style={{height: SIZES[props.size]}}/>
  )
}

export default Divider
